import Collaborators from "../../../models/loyaltyPanel/Collaborators";

export default {
    namespaced: true,

    state: () => ({
        companies : [],
        collaborators : [],
        collaboratorData: new Collaborators(),
        successCode: false,
        companiesLoading: false,
        loading: false,
        serverItemsLength: 0,
    }),
    getters: {
        companies: state => state.companies,
        collaborators: state => state.collaborators,
        collaboratorData: state => state.collaboratorData,
        successCode: state => state.successCode,
        companiesLoading: state => state.companiesLoading,
        loading: state => state.loading,
        serverItemsLength: state => state.serverItemsLength,
      
    },

    mutations: {
        setCompanies(state, payload) {
            state.companies = payload;
        },
        setServerItemsLength(state, payload) {
            state.serverItemsLength = payload;
        },
        setCollaborators(state, payload) {
            state.collaborators = payload;
        },
        setSuccessCode: (state, payload) => {
            state.successCode = payload;
        },
        setCompaniesLoading: (state, payload) => {
            state.companiesLoading = payload;
        },
        setCollaboratorData: (state, payload) => {
            state.collaboratorData = new Collaborators(payload);
        },
        setLoading: (state, payload) => {
            state.loading = payload;
        },
    },

    actions: {
        
        async loadCompanies({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                commit("setCompaniesLoading", true);
                let resData =  await Collaborators.getAvailable()
                let companies = resData.data.data.companies;
                let pagination = resData.data.data.pagination;

                companies.map(item => {
                    for (const [k, v] of Object.entries(item)) {
                        item[k] = v || '-'
                      }
                })

                commit("setCompanies", companies);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
                commit("setCompaniesLoading", false);
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setCompaniesLoading", false);
            }
        },
        
        async loadSynergies({ commit }, data) {
            try {
                commit("setLoading", true);
                let filter = ""
                Object.keys(data.filters).map((key) => {
                    if(data.filters[key]){
                        filter += "&" + key + "=" + data.filters[key]   
                    }
                })
                let resData =  await Collaborators.get(data.query, filter)
                let synergies = resData.data.data.synergies;
                let pagination = resData.data.data.pagination;
                synergies.map(item => {
                    for (const [k, v] of Object.entries(item)) {
                        // v&&(item[k] = '-')
                        item[k] = v || '-'
                      }
                })
                commit("setCollaborators", synergies);
                commit("setServerItemsLength", pagination.total);
                
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
                commit("setLoading", false);
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setLoading", false);
            }
        },

        async addNewCollaborator({commit,state,dispatch, getters}, data){
            try{
                commit("setLoading", true);
                commit("setSuccessCode", false)
                let collaboratorDetails = new Collaborators({...data, to_company_id: data.store_id})
                let res = await Collaborators.create(collaboratorDetails);

                if(res.code == 200) {
                    commit("setSuccessCode", true)
                    let newSynergy = res.data.data

                    commit("setCollaborators", [...getters.collaborators.filter(x => x.to_company !== newSynergy.to_company), newSynergy])

                }

                commit("setCollaboratorData", new Collaborators())
  
                commit("setErrorMessage",
                    "", { root: true }
                );

                setTimeout( () => {
                    commit("setNewCardIsValid", null);
 
                }, 3000 );
                commit("setLoading", false);
            } catch (ex) {
                commit("setLoading", false);
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
            }
        },
        
        async doAction({ commit }, actionData) {
            try {
                commit("setLoading", true);
                await Collaborators.doAction(actionData)
                commit("setLoading", false, { root: true });
                commit("setLoading", false);
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setLoading", false);
            }
        },
    }
};

